export default "__VITE_ASSET__16cec922__"